module.exports = __webpack_public_path__ + "img/empty_layout.5535283c.svg";